import React from 'react';
import { Box, Divider } from '@mui/material';
import { borderRadius, boxShadows, palette, spaces } from '../../../assets/styles/themes/tokens';
import add from '../../../assets/lernsets/icons/add.svg';
import ButtonWithMenu from '../ButtonWithMenu';
import { useTranslation } from 'react-i18next';
import blankPage from '../../../assets/lernsets/icons/blankPage.svg';
import magicPen from '../../../assets/lernsets/icons/magicpen.svg';
import { Search } from '@mui/icons-material';

interface OwnProps {
    label: string;
    positionedAfterPartIndex: number;
    onCreateBlankPageClick: (index: number) => void;
    onRedirectToMuClick: () => void;
    onGenerateWorksheetClick: () => void;
    isDisabled?: boolean;
}

const AddMaterialBetweenParts: React.FC<OwnProps> = (props) => {
  const { t } = useTranslation();
  const { 
    positionedAfterPartIndex, 
    onCreateBlankPageClick, 
    onRedirectToMuClick, 
    onGenerateWorksheetClick, 
    isDisabled 
  } = props;

  const divider = <Divider sx={{ 
    flex: '1 0 0',
  }} />;
  
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      padding: `0px ${spaces.lg}`,
      alignItems: 'center',
      gap: spaces.md,
      height: spaces.xl,
    }}>
      {divider}
      <ButtonWithMenu
        disabled={isDisabled}
        color='inherit'
        variant='outlined'
        dataTestId='add-mu-material-button-between-parts'
        icon={add}
        label={t('Add mU material')}
        options={[
          {
            id: 'add-blank-page-button-between-parts',
            icon: blankPage,
            text: t('Blank page'),
            onClick: () => onCreateBlankPageClick(positionedAfterPartIndex),
            isVisible: true,
          },
          {
            id: 'generate-worksheet',
            text: t('Generate worksheets'),
            onClick: () => onGenerateWorksheetClick(),
            icon: magicPen,
            isVisible: true,
          },
          {
            id: 'search-at-mu',
            text: t('Search at mU'),
            onClick: () => onRedirectToMuClick(),
            icon: Search,
            isVisible: true
          },
        ]}
        menuProps={{
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
        }}
        buttonStyles={{
          backgroundColor: palette.secondary.contrastText,
          border: 'transparent',
          borderRadius: borderRadius.sm,
          boxShadow: boxShadows.elevation4,
          padding: `${spaces.xs} ${spaces.lg}`,
          zIndex: 1,
          '&:hover': {
            backgroundColor: palette.common.white,
          },
        }}
      />
      {divider}
    </Box>
  );
};

export default AddMaterialBetweenParts;
